export class FileModel {
  name?: string;
  url?: string;
  typeCode?: number;
  editBlocked?: boolean;

  static isImage(fileName: string) {
    const imageExtensions = ['png', 'gif', 'jpg', 'jpeg', 'bmp'];
    return imageExtensions.some(x => x === fileName.split('.').pop()?.toLowerCase());
  }

  static isPdf(fileName: string) {
    return fileName.split('.').pop()?.startsWith('pdf');
  }
}
